import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Divider } from "@mui/material";
import { twMerge } from "tailwind-merge";

import { useAppMeta, useAuth } from "hooks";

const GuestLayout = () => {
  React.useEffect(() => {
    window && window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="bg-red-20 relative flex min-h-screen flex-col">
      <GuestHeader />

      <div className="relative flex flex-grow flex-col overflow-scroll">
        <GuestContainer className="flex-grow">
          <div className="py-8">
            <Outlet />
          </div>
        </GuestContainer>

        <GuestFooter />
      </div>
    </div>
  );
};

export default GuestLayout;

const GuestContainer = ({ children, className }) => {
  return (
    <div
      className={twMerge(
        "container relative mx-auto max-w-7xl px-4",
        className
      )}
    >
      {children}
    </div>
  );
};

const GuestHeader = () => {
  const { appMeta } = useAppMeta();

  const { loggedInUser } = useAuth();

  const navLinks = [
    {
      name: "Courses",
      link: "/public/courses",
    },
    {
      name: "Analytics",
      link: "/analytics",
    },
    {
      name: !loggedInUser ? "Sign In" : "Dashboard",
      link: "/sign-in",
    },
  ];

  return (
    <div className="flex-shrink-0 flex-grow-0">
      <GuestContainer>
        <div className="flex justify-between py-6">
          <NavLink to="/">
            <img src={appMeta.logo} alt={appMeta.title} className="h-6" />
          </NavLink>

          <div className="flex gap-6">
            {navLinks.map(({ name, link }, index) => (
              <NavLink
                key={index + name}
                to={link}
                className={({ isActive }) =>
                  twMerge(
                    "font-medium text-gray-500",
                    isActive && "text-blue-600"
                  )
                }
              >
                {name}
              </NavLink>
            ))}
          </div>
        </div>
      </GuestContainer>

      <Divider />
    </div>
  );
};

const GuestFooter = () => {
  return (
    <div className="flex-shrink-0 flex-grow-0">
      <Divider />

      <GuestContainer>
        <div className="py-6"></div>
      </GuestContainer>
    </div>
  );
};
